"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommunityUnreadMarkShown = void 0;
var isCommunityUnreadMarkShown = function isCommunityUnreadMarkShown(_ref) {
  var unreadMessages = _ref.unreadMessages,
    banned = _ref.banned;
  return !banned && (unreadMessages.groupChannels > 0 || unreadMessages.communityChannels > 0);
};
exports.isCommunityUnreadMarkShown = isCommunityUnreadMarkShown;